export const providerClear = 'PROVIDER_CLEAR';
export const providerFetch = 'PROVIDER_FETCH';
export const providerSelected = 'PROVIDER_SELECTED';

export default {
    clear: providerClear,
    fetch: providerFetch,
    selected: providerSelected
};
